// extracted by mini-css-extract-plugin
export var label = "prices-module--label--754ac";
export var price = "prices-module--price--44c84";
export var wrapper = "prices-module--wrapper--0cb14";